import { render, staticRenderFns } from "./InputFileDefault.vue?vue&type=template&id=4b165d9b"
import script from "./InputFileDefault.vue?vue&type=script&lang=js"
export * from "./InputFileDefault.vue?vue&type=script&lang=js"
import style0 from "./InputFileDefault.vue?vue&type=style&index=0&id=4b165d9b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports